<template>
  <div class="vtm-listpage">
    <!-- 页头 -->
    <div v-if="title" class="vtm-page-head">
      <div>
        <h1 class="vtm-page-head__title">{{ title }}</h1>
        <div v-if="subtitle" class="vtm-page-head__sub">{{ subtitle }}</div>
      </div>
      <div class="vtm-listpage__head-actions">
        <slot name="head-actions"></slot>
      </div>
    </div>

    <!-- 筛选条 -->
    <slot name="filters"></slot>

    <!-- 内容：加载 / 错误 / 空 / 数据 -->
    <div v-loading="loading" :element-loading-text="$t('common.loading')" class="vtm-listpage__body">
      <div v-if="error" class="vtm-listpage__state">
        <i class="el-icon-warning-outline vtm-listpage__state-icon vtm-listpage__state-icon--crit"></i>
        <div class="vtm-listpage__state-title">{{ $t("common.loadFailed") }}</div>
        <div class="vtm-listpage__state-sub">{{ $t("common.loadFailedHint") }}</div>
        <el-button size="small" @click="$emit('retry')">{{ $t("common.retry") }}</el-button>
      </div>
      <!-- 空状态里的操作入口：列表为空时表格（连同它工具栏上的「新增」按钮）是隐藏的，
           没有这个插槽就会出现「提示你去新增、却没有任何按钮可点」的死角 -->
      <el-empty v-if="!error && !loading && empty" :description="emptyText || $t('common.noData')">
        <slot name="empty-action"></slot>
      </el-empty>
      <!-- 默认插槽常驻挂载（用 v-show 而非 v-if），保证放在其中的
           append-to-body 弹窗在列表为空时仍能打开（否则新增/导入无法触发） -->
      <div v-show="!error && !empty" class="vtm-listpage__slot"><slot></slot></div>
    </div>

    <!-- 统一分页（含每页条数选择） -->
    <el-pagination
      v-if="!error && !empty && total > 0"
      background
      class="vtm-listpage__pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="pageIndex"
      :total="total"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      @size-change="size => $emit('size-change', size)"
      @current-change="page => $emit('page-change', page)"
    ></el-pagination>
  </div>
</template>

<script>
  // 标准列表页骨架：页头 + 筛选 + 状态三态（加载/错误/空）+ 统一分页。
  // 逐屏替换手写的「工具条 + 表格 + 分页」样板。参考实现：OrderRefund.vue
  export default {
    name: "ListPage",
    props: {
      title: { type: String, default: "" },
      subtitle: { type: String, default: "" },
      loading: { type: Boolean, default: false },
      error: { type: Boolean, default: false },
      empty: { type: Boolean, default: false },
      emptyText: { type: String, default: "" },
      total: { type: Number, default: 0 },
      pageIndex: { type: Number, default: 1 },
      pageSize: { type: Number, default: 10 },
      pageSizes: { type: Array, default: () => [10, 20, 50, 100] }
    }
  };
</script>

<style scoped lang="scss">
  .vtm-listpage {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  .vtm-listpage__head-actions {
    display: flex;
    gap: 8px;
  }

  .vtm-listpage__body {
    flex: 1;
    padding: 14px 16px 0;
    min-height: 200px;
  }

  /* 布局透明的插槽容器：不影响原有排版，仅承载 v-show 显隐 */
  .vtm-listpage__slot {
    display: contents;
  }

  .vtm-listpage__state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 56px 20px;
    text-align: center;
  }

  .vtm-listpage__state-icon {
    font-size: 34px;
    color: var(--vtm-ink-3);
  }

  .vtm-listpage__state-icon--crit {
    color: var(--vtm-crit);
  }

  .vtm-listpage__state-title {
    font-family: var(--vtm-display);
    font-size: 15px;
    font-weight: 600;
    color: var(--vtm-heading);
  }

  .vtm-listpage__state-sub {
    font-size: 13px;
    color: var(--vtm-ink-2);
    margin-bottom: 6px;
  }

  .vtm-listpage__pagination {
    padding: 14px 16px !important;
    margin-top: 0;
  }
</style>

